import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Item from './Item'
import bemClass from './../../../utils/bemClass'
import api from './../../../api'

import './ThisWeek.css'

const cn = bemClass('ThisWeek')

class ThisWeek extends PureComponent {
    state = { items: [] }

    getApi = async () => {
        const apiItems = await api('pages/events')
        const items = apiItems.filter(item => item.thisWeek)

        this.setState({ items })
    }

    componentDidMount() {
        this.getApi()
    }

    render() {
        const { className } = this.props
        const { items } = this.state

        return (
            <div className={`${cn()} ${className}`}>
                <div className={cn('header')}>
                    W tym tygodniu
                </div>
                {items.map(item =>
                    <Item
                        title={item.title}
                        date={item.dateString}
                        hour={item.hour}
                        key={item.url}
                    />
                )}
                {!items.length && <p className={cn('paragraph')}>Zapraszamy na kawę</p> }
            </div>
        )
    }
}

ThisWeek.propTypes = {
    className: PropTypes.string,
}

ThisWeek.defaultProps = {
    className: '',
}

export default ThisWeek


// WEBPACK FOOTER //
// ./src/components/FrontPage/ThisWeek/ThisWeek.jsx